import { render, staticRenderFns } from "./EditorialPush.vue?vue&type=template&id=06eca1ba"
import script from "./EditorialPush.vue?vue&type=script&lang=ts"
export * from "./EditorialPush.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports